import { router } from "@inertiajs/react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { LandingPage } from "@/components/landing-page"
import type { LandingOrganizationMembershipInvitationsShowProps } from "@/types/generated"

const OrganizationMembershipInvitationShowPage = ({
  organization,
  inviterEmail,
  organizationName
}: LandingOrganizationMembershipInvitationsShowProps) => {
  const { t } = useTranslation()

  const handleAccept = () => {
    router.post(`/organizations/${organization.id}/organization_membership_invitation/accept`)
  }

  return (
    <LandingPage organizationName={organizationName}>
      <div className="flex flex-col gap-8 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold">
            {t("organization_membership_invitations.show.title", { organization_name: organization.name })}
          </h1>
          {inviterEmail && (
            <p className="text-sm text-muted-foreground">
              {t("organization_membership_invitations.show.invited_by", { email: inviterEmail })}
            </p>
          )}
        </div>

        <Button onClick={handleAccept} className="w-full">
          {t("organization_membership_invitations.show.accept")}
        </Button>
      </div>
    </LandingPage>
  )
}

export default OrganizationMembershipInvitationShowPage
